import { render, staticRenderFns } from "./footerNav.vue?vue&type=template&id=c8213a1c&lang=pug&"
import script from "./footerNav.vue?vue&type=script&lang=js&"
export * from "./footerNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports